import pro1 from '../assets/Home/pro1.png';
import pro2 from '../assets/Home/pro2.png';
import pro3 from '../assets/Home/pro3.png';
import pro4 from '../assets/Home/pro4.png';
import panelSaw3200AImg from '../assets/Products/PanelSaw3200A.png';
import panelSaw3200AHVImg from '../assets/Products/PanelSaw3200A.HV.png';
import panelSaw3200APlusImg from '../assets/Products/PanelSaw3200A++.png';

export const categoriesData = {
  'panel-saw': {
    slug: 'panel-saw',
    title: 'Panel Saw Machines',
    subtitle: 'High-Precision Cutting for Wood, MDF, Acrylic & Laminated Panels.',
    breadcrumb: 'HOME / PRODUCTS / PANEL SAW',
    models: [
      {
        id: 'ups-3200a',
        name: 'Panel Saw 3200 A',
        slug: 'ups-3200a',
        description: 'A reliable panel cutting solution designed for accurate and efficient processing of plywood, MDF, particle board, acrylic, and laminated panels.',
        image: panelSaw3200AImg
      },
      {
        id: 'ups-3200a-hv',
        name: 'Panel Saw 3200 A.HV',
        slug: 'ups-3200a-hv',
        description: 'A professional panel saw designed for precise and consistent cutting performance, supporting smooth operation across demanding woodworking and furniture production applications.',
        image: panelSaw3200AHVImg
      },
      {
        id: 'ups-3200a-plus',
        name: 'Panel Saw 3200 A++',
        slug: 'ups-3200a-plus',
        description: 'An advanced panel cutting solution designed for high-performance woodworking, delivering accurate cuts, reliable operation, and efficient panel processing.',
        image: panelSaw3200APlusImg
      }
    ]
  },

  'automatic-edgebander': {
    slug: 'automatic-edgebander',
    title: 'Automatic Edgebander Machines',
    subtitle: 'High-Speed Automated Edge Sealing, Trimming & Buffing.',
    breadcrumb: 'HOME / PRODUCTS / AUTOMATIC EDGEBANDER',
    models: [
      {
        id: 'ueb-240-s',
        name: 'Automatic Edgebander UEB-240 S',
        slug: 'ueb-240-s',
        description: 'Multi-stage automatic edge finishing with pre-heating and dual-blade trimming.',
        image: pro3
      },
      {
        id: 'ueb-310-c',
        name: 'Automatic Edgebander UEB-310 C',
        slug: 'ueb-310-c',
        description: 'Compact automatic edgebander with corner rounding and scraping units.',
        image: pro1
      },
      {
        id: 'ueb-540-pc',
        name: 'Automatic Edgebander UEB-540 PC',
        slug: 'ueb-540-pc',
        description: 'High performance edgebander with pre-milling and precision glue application.',
        image: pro4
      },
      {
        id: 'ueb-640-pcgd',
        name: 'Automatic Edgebander UEB-640 PCGD',
        slug: 'ueb-640-pcgd',
        description: 'Heavy industrial edgebander with pneumatic tape feed and grooving unit.',
        image: pro2
      },
      {
        id: 'ueb-860-pc',
        name: 'Automatic Edgebander UEB-860 PC',
        slug: 'ueb-860-pc',
        description: 'High-speed multi-stage industrial edgebander for high volume production.',
        image: pro4
      },
      {
        id: 'ueb-860-pcgd',
        name: 'Automatic Edgebander UEB-860 PCGD',
        slug: 'ueb-860-pcgd',
        description: 'Flagship automatic edgebanding solution with dual grooving and corner rounding.',
        image: pro1
      }
    ]
  },

  'manual-edgebander': {
    slug: 'manual-edgebander',
    title: 'Manual Edgebander Machines',
    subtitle: 'Flexible Edge Sealing for Curved and Straight Profiles.',
    breadcrumb: 'HOME / PRODUCTS / MANUAL EDGEBANDER',
    models: [
      {
        id: 'u-1006',
        name: 'Manual Edgebander U-1006',
        slug: 'u-1006',
        description: 'Portable glue pot edgebander for straight and contour board edges.',
        image: pro3
      },
      {
        id: 'u-1006-e',
        name: 'Manual Edgebander U-1006-E',
        slug: 'u-1006-e',
        description: 'Electronic speed control manual edgebander for PVC and veneer tapes.',
        image: pro1
      },
      {
        id: 'u-1006-45',
        name: 'Manual Edgebander U-1006-45°',
        slug: 'u-1006-45',
        description: 'Bevel edge banding machine designed for 45-degree angle panel edges.',
        image: pro2
      }
    ]
  },

  'beam-saw': {
    slug: 'beam-saw',
    title: 'Auto CNC Beam Saw Machines',
    subtitle: 'High-Volume Precision Beam Sawing & Sheet Sizing.',
    breadcrumb: 'HOME / PRODUCTS / CNC BEAM SAW',
    models: [
      {
        id: 'ubs-2800-auto',
        name: 'Auto Beam Saw UBS 2800 AUTO',
        slug: 'ubs-2800-auto',
        description: 'Precision cutting, reliable automation, and heavy-duty pusher grippers.',
        image: pro1
      },
      {
        id: 'ubs-3200-auto',
        name: 'Auto Beam Saw UBS 3200 AUTO',
        slug: 'ubs-3200-auto',
        description: 'High-speed heavy beam saw for multi-sheet production lines.',
        image: pro4
      },
      {
        id: 'ubs-3200-auto-plus',
        name: 'Auto Beam Saw UBS 3200 AUTO+',
        slug: 'ubs-3200-auto-plus',
        description: 'Flagship CNC beam saw with rear lifting table and air-flotation bed.',
        image: pro2
      }
    ]
  },

  'six-sided-drilling': {
    slug: 'six-sided-drilling',
    title: 'CNC Six Sided Drilling Machines',
    subtitle: '6-Sided Boring & Grooving in One Continuous Pass.',
    breadcrumb: 'HOME / PRODUCTS / CNC SIX SIDED DRILLING',
    models: [
      {
        id: 'u-612ks',
        name: 'CNC Six Sided Drilling U-612KS',
        slug: 'u-612ks',
        description: 'Dual drill bank six-sided CNC boring machine with pneumatic clamps.',
        image: pro2
      }
    ]
  },

  'cold-press': {
    slug: 'cold-press',
    title: 'Hydraulic Cold Press Machines',
    subtitle: 'Heavy Duty Laminate & Veneer Board Pressing Power.',
    breadcrumb: 'HOME / PRODUCTS / HYDRAULIC COLD PRESS',
    models: [
      {
        id: 'ucp-1001',
        name: 'Hydraulic Cold Press UCP-1001',
        slug: 'ucp-1001',
        description: 'Solid steel multi-cylinder hydraulic cold press for uniform panel bonding.',
        image: pro1
      },
      {
        id: 'ucp-1004',
        name: 'Hydraulic Cold Press UCP-1004',
        slug: 'ucp-1004',
        description: 'Heavy duty automated multi-platen cold press for doors and blockboards.',
        image: pro4
      }
    ]
  },

  'hot-press': {
    slug: 'hot-press',
    title: 'Hydraulic Hot Press Machines',
    subtitle: 'Thermal Curing & High Temperature Panel Laminating.',
    breadcrumb: 'HOME / PRODUCTS / HYDRAULIC HOT PRESS',
    models: [
      {
        id: 'uhp-1002',
        name: 'Hydraulic Hot Press UHP-1002',
        slug: 'uhp-1002',
        description: 'Heated oil platen hydraulic press system for fast veneer pressing.',
        image: pro3
      }
    ]
  },

  'multi-boring': {
    slug: 'multi-boring',
    title: 'Multi Boring Machines',
    subtitle: 'Fast Line Drilling & Precision Cabinet Joint Hole Boring.',
    breadcrumb: 'HOME / PRODUCTS / MULTI BORING',
    models: [
      {
        id: 'umb-42',
        name: 'Multi Boring UMB 42',
        slug: 'umb-42',
        description: 'Multi-spindle line boring machine for cabinet assembly dowel holes.',
        image: pro1
      },
      {
        id: 'umb-63-a',
        name: 'Multi Boring UMB 63 A',
        slug: 'umb-63-a',
        description: 'Triple-head multi boring machine with pneumatic vertical and horizontal tilting.',
        image: pro2
      }
    ]
  },

  'cnc-router': {
    slug: 'cnc-router',
    title: 'CNC Router Machines',
    subtitle: 'Advanced 2D/3D Routing, Carving & Nesting Solutions.',
    breadcrumb: 'HOME / PRODUCTS / CNC ROUTER',
    models: [
      {
        id: 'ucr-1325-a',
        name: 'CNC Router UCR 1325 A',
        slug: 'ucr-1325-a',
        description: 'Heavy duty CNC router with multi-zone vacuum bed and air cooling.',
        image: pro2
      },
      {
        id: 'ucr-1325-ss',
        name: 'CNC Router UCR 1325 SS',
        slug: 'ucr-1325-ss',
        description: 'Dual spindle side-by-side automatic tool change CNC router.',
        image: pro4
      }
    ]
  },

  'vacuum-press': {
    slug: 'vacuum-press',
    title: 'Vacuum Press Machines',
    subtitle: '3D Thermofoil Membrane Pressing for Molded Panel Doors.',
    breadcrumb: 'HOME / PRODUCTS / VACUUM PRESS',
    models: [
      {
        id: 'uvp-1010',
        name: 'Vacuum Press UVP 1010',
        slug: 'uvp-1010',
        description: 'Automatic silicone membrane vacuum press for PVC membrane foil lamination.',
        image: pro3
      }
    ]
  },

  'spindle-moulder': {
    slug: 'spindle-moulder',
    title: 'Spindle Moulder Machines',
    subtitle: 'High Precision Wood Shaping, Profiling & Moulding.',
    breadcrumb: 'HOME / PRODUCTS / SPINDLE MOULDER',
    models: [
      {
        id: 'u-1004-1004a',
        name: 'Spindle Moulder U 1004 / 1004A',
        slug: 'u-1004-1004a',
        description: 'Heavy cast-iron table spindle shaper for custom architectural wood mouldings.',
        image: pro1
      }
    ]
  },

  'post-forming': {
    slug: 'post-forming',
    title: 'Post Forming Machines',
    subtitle: 'Seamless Curved Laminate Edge Bending & Thermo-Forming.',
    breadcrumb: 'HOME / PRODUCTS / POST FORMING',
    models: [
      {
        id: 'upf-1000',
        name: 'Post Forming UPF 1000',
        slug: 'upf-1000',
        description: 'Semi-automatic post forming machine for kitchen countertop laminate wrapping.',
        image: pro4
      }
    ]
  }
};

export const defaultCategoryData = {
  slug: 'industrial-machinery',
  title: 'Industrial CNC Machinery',
  subtitle: 'Precision Engineering. Heavy Duty Build. Continuous Output.',
  breadcrumb: 'HOME / PRODUCTS / MACHINERY',
  models: [
    {
      id: 'ubs-2800-auto',
      name: 'Auto CNC Beam Saw UBS 2800',
      slug: 'ubs-2800-auto',
      description: 'High-speed precision panel cutting for modern furniture manufacturing.',
      image: pro1
    }
  ]
};

export const getCategoryBySlug = (slug) => {
  if (!slug) return categoriesData['panel-saw'];
  const formatted = slug.toLowerCase().trim();
  if (categoriesData[formatted]) return categoriesData[formatted];
  
  const titleText = formatted
    .split('-')
    .map(w => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');

  return {
    ...defaultCategoryData,
    slug: formatted,
    title: titleText + ' Machines',
    breadcrumb: 'HOME / PRODUCTS / ' + titleText.toUpperCase(),
    models: [
      {
        id: formatted + '-1',
        name: titleText + ' Solution',
        slug: formatted,
        description: 'Precision industrial ' + titleText.toLowerCase() + ' system for modern manufacturing.',
        image: pro1
      }
    ]
  };
};
